import script from "./DeviceAlertPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceAlertPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceAlertPopup.vue?vue&type=style&index=0&id=4c78af97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c78af97"]])

export default __exports__